import type { FileTypes } from "@similarweb/ai-kit";
import { AIFileAttachment, makeAssistantToolUI } from "@similarweb/ai-kit";
import { allTrackers } from "app/services/track/track";

type FileAttachmentToolArgs = {
    fileType: FileTypes;
    title: string;
    downloadUrl?: string;
    onDownload?: () => Promise<void> | void;
};

const handleOnDownload = () => {
    allTrackers.dispatchTrackEvent("Button", "click", "SEO Agent/Download PDF");
};

export const FileAttachmentTool = makeAssistantToolUI<FileAttachmentToolArgs, string>({
    toolName: "file_attachment",
    render: function FileAttachmentToolUI({ args }) {
        return (
            <AIFileAttachment
                {...args}
                onDownload={handleOnDownload}
            />
        );
    },
});
